module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURUdwTFak/1ak/1Wq/73b/1ek/2+x/6RvWz8AAAAEdFJOUwCH5Qadg8kDAAAAl0lEQVRIx2NgoApgFgrFAhQN4AoYQ7ECAbgCphAXLMBVAa6AFbuCACQFrqFABAIuLqlQC1JwKYC5IARFAZLJoXBNJCkgaAVBRxL0JkEFbpgBjR4OGADNkQHoMcw6oApYA8CQAgVkuoFQQBEMaqrEZgo6RnckJkb1JjZMkgJCVhB05Gg4jIbDaDiQHA4Eq0WCFSvBqpkiAAAb0GyE3S0sOgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/American-Credit-Vendor-Benefits-Icon-3.png
// module id = 720
// module chunks = 5